import { Chip } from '@mui/material'
import { FC } from 'react'
import CloseIcon from '../../../../assets/images/close-icon.svg?react'

interface InputDisplayChipProps {
  inputText: string
  onDelete: () => void
}

export const InputDisplayChip: FC<InputDisplayChipProps> = ({ inputText, onDelete }) => {
  return (
    <Chip
      label={inputText}
      onDelete={onDelete}
      deleteIcon={<CloseIcon style={{ width: 'var(--spacing-s)', height: 'var(--spacing-s)' }} />}
      sx={{
        height: 'var(--spacing-2xl)',
        fontSize: 'var(--size-s)',
        fontWeight: '400',
        padding: '12px var(--spacing-s) 12px var(--spacing-s)',
        borderRadius: '32px',
        color: 'var(--text-primary)',
        background: 'var(--bg-surface-medium)'
      }}
    />
  )
}
